import ReactGA from 'react-ga4';
import config from '../config';

const Analytics = {
  /**
   * Initialize Analytics (GA4 and/or GTM)
   */
  init: () => {
    // Initialize Google Analytics 4
    if (config.GOOGLE_ANALYTICS_ID && config.GOOGLE_ANALYTICS_ID !== 'G-XXXXXXXXXX') {
      ReactGA.initialize(config.GOOGLE_ANALYTICS_ID);
      console.log('Google Analytics (GA4) initialized:', config.GOOGLE_ANALYTICS_ID);
    }

    // Initialize dataLayer for GTM (GTM script is in index.html)
    if (config.GOOGLE_TAG_MANAGER_ID && config.GOOGLE_TAG_MANAGER_ID !== 'GTM-XXXXXXXX') {
      window.dataLayer = window.dataLayer || [];
      console.log('Google Tag Manager dataLayer initialized:', config.GOOGLE_TAG_MANAGER_ID);
    }
  },

  /**
   * Track a page view
   * @param {string} path - The current path
   */
  sendPageView: (path) => {
    // GA4 Tracking
    if (config.GOOGLE_ANALYTICS_ID && config.GOOGLE_ANALYTICS_ID !== 'G-XXXXXXXXXX') {
      ReactGA.send({ hitType: "pageview", page: path });
    }

    // GTM Tracking (Push to dataLayer)
    if (config.GOOGLE_TAG_MANAGER_ID && window.dataLayer) {
      window.dataLayer.push({
        event: 'page_view',
        page_path: path
      });
    }
  },

  /**
   * Track a custom event
   * @param {string} category - Event category
   * @param {string} action - Event action
   * @param {string} label - Event label (optional)
   * @param {number} value - Event value (optional)
   */
  trackEvent: (category, action, label, value) => {
    // GA4 Tracking
    if (config.GOOGLE_ANALYTICS_ID && config.GOOGLE_ANALYTICS_ID !== 'G-XXXXXXXXXX') {
      ReactGA.event({
        category,
        action,
        label,
        value
      });
    }

    // GTM Tracking
    if (config.GOOGLE_TAG_MANAGER_ID && window.dataLayer) {
      window.dataLayer.push({
        event: action, // Use action as the event name
        category: category,
        label: label,
        value: value
      });
    }
  }
};

export default Analytics;
